<section class="hero is-warning ">
    <div class="hero-head">
        <nav class="navbar">
            <div class="navbar-brand">

                <a class="navbar-item" routerLink="/dashboard" routerLinkActive="active">
                    <img [src]="configuracion.empresa.logo ? API_PATH+'/adjunto/configuracion/'+configuracion.empresa.logo : './assets/yoursoft.png'"
                        alt="Logo" class="profile">
                </a>
                <a class="navbar-item"  routerLinkActive="active">
                    <span class="icon fa-2x">
                        <i class="icon-html"></i>
                    </span>
                    &nbsp;
                    <h1 class="title">404</h1>
                </a>

            </div>
            <div id="navbarMenuHeroA" class="navbar-menu" >
                <div class="navbar-end">
                    <a class="navbar-item is-active">
                        <span class="nav-item is-hidden-mobile " style="font-size: 1.3em;">
                            {{configuracion.empresa.nombre }} &nbsp;
                            <span class="icon">
                                <i class="icon-next-2"></i>
                            </span>
                            &nbsp; suc: {{configuracion.sucursal.nombre}}
                        </span>

                    </a>

                    <a class="navbar-item is-hidden-tablet tooltip"  >
                        <span class="icon">
                            <i class="fa fa-navicon"></i>
                        </span>
                        <span class="tooltiptext">Menú Opciones</span>
                    </a>
                    <a class="navbar-item tooltip" (click)="hub.toggle()">
                        <span class="icon">
                            <i class="icon-home"></i>
                        </span>
                        <span class="tooltiptext">Menú Modulos</span>
                    </a>

                    <a class="navbar-item is-hidden-mobile tooltip" (click)="perfil.toggle()">

                        <figure class="image" style="width:26px;">
                            <img [src]="usuario.foto ? API_PATH+'/adjunto/usuario/'+usuario.foto : usuario.avatar ?  usuario.avatar : './assets/128x128.png'" alt="Image" class="profile">
                        </figure>
                        &nbsp;
                        <span>{{ usuario.nombre }} {{ usuario.apellidos }}</span>
                        <span class="tooltiptext">Perfil</span>
                    </a>
                    <a class="navbar-item is-hidden-tablet tooltip" (click)="perfil.toggle()">

                        <figure class="image" style="width:26px;">
                            <img [src]="usuario.foto ? API_PATH+'/adjunto/usuario/'+usuario.foto : usuario.avatar ?  usuario.avatar : './assets/128x128.png'" alt="Image" class="profile">
                        </figure>
                        <span class="tooltiptext">Perfil</span>
                    </a>
                </div>
            </div>
        </nav>
    </div>
</section>

<app-hub #hub></app-hub>
<app-perfil #perfil></app-perfil>
<section class="hero is-dark is-fullheight has-text-centered">
  <div class="hero-body">
    <div class="container">

      <figure class="image" >
        <span class="icon has-text-warning fa-5x">
            <i class="icon-404-error fa-5x"></i>
        </span>
      </figure>
      <br>
      <h1 class="title">¡Lo sentimos!</h1>
      <h2 class="subtitle">El contenido que intentas buscar <strong>no existe</strong>.</h2>
    </div>
  </div>
</section>

